import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Generator } from './pages/Generator';
import { Dashboard } from './pages/Dashboard';
import { About } from './pages/About';
import { FAQ as FAQPage } from './pages/FAQ';
import { Contact } from './pages/Contact';
import { Pricing } from './pages/Pricing';
import { TermsOfPolicy } from './pages/TermsOfPolicy';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { NotFound } from './pages/NotFound';
import { HomePage } from './pages/HomePage';
import StartFunnel from '../pages/StartFunnel';
import { GetOffers } from './pages/GetOffers';
import GetOffersFunnel from '../pages/GetOffersFunnel';
import GetOffersPricing from '../pages/GetOffersPricing';
import { useLocation } from '../hooks/useLocation';
import { motion, AnimatePresence } from 'framer-motion';
import { signOutUser } from '../utils/firebase';

export function Routes() {
  const { user, subscription } = useAuth();
  const { pathname, queryParams } = useLocation();
  const hasActiveSubscription = subscription?.status === 'active' || subscription?.status === 'trialing';

  if (user?.isAnonymous && queryParams['canceled'] == 'true') {
    signOutUser()
      .then(() => {
        window.location.search = '';
      })
      .catch((error) => {
        console.error('Error signing out user:', error);
      });
  }

  // Redirect to home if accessing dashboard without auth
  if (pathname.startsWith('/dashboard') && !user) {
    window.history.pushState({}, '', '/');
    window.dispatchEvent(new PopStateEvent('popstate'));
    return null;
  }

  // Clean up trailing slashes
  const cleanPathname = pathname.endsWith('/') && pathname !== '/' 
    ? pathname.slice(0, -1) 
    : pathname;

  // Render appropriate component based on pathname
  const renderRoute = () => {
    switch (cleanPathname) {
      case '/about':
        return <About />;
      case '/faq':
        return <FAQPage />;
      case '/contact':
        return <Contact />;
      case '/pricing':
        return <Pricing />;
      case '/terms':
        return <TermsOfPolicy />;
      case '/privacy':
        return <PrivacyPolicy />;
      case '/getoffers':
        return <GetOffers />;
      case '/getoffers/funnel':
        return <GetOffersFunnel />;
      case '/getoffers/pricing':
        return <GetOffersPricing />;
      case '/dashboard':
      case '/dashboard/history':
      case '/dashboard/documents':
      case '/dashboard/profile':
        return <Dashboard />;
      case '/generator':
        return <Generator />;
      case '/start':
        return <StartFunnel />;
      case '/':
        return <HomePage />;
      default:
        return <NotFound />;
    }
  };

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={cleanPathname}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
      >
        {renderRoute()}
      </motion.div>
    </AnimatePresence>
  );
}